const translations = {
  "login.Title": "Login",
  "login.Username": "Username",
  "login.Password": "Password",
  "login.UserNotFound": "User Name / Password incorrect!",
  "login.Login": "Login",
  "login.RememberMe": "Remember me",
  "login.ForgotPassword": "Forgot password?",
  "USER_PASS_INCORRECT": "The user name or password is incorrect."
};

export default translations;
